import React, {
  forwardRef, useEffect, useImperativeHandle, useState,
} from 'react';
import { Grid } from '@mui/material';
import CardWrapper from 'components/Financial/CardWrapper';
import { FieldArray, FormikProvider, useFormik } from 'formik';
import InputGroup from './InputGroup';
import api from 'services/api';
import { inputSchema } from './schema';
import { useLoadDataByLocation } from 'hooks/useLoadDataByLocation';
import { totalValue } from 'pages/purchase/helpers';

function Input({ updateTotalPrice, callback = () => {} }, ref) {
  const formik = useFormik({
    initialValues: {
      items: [
        {
          supply: null,
          quantity: '',
          unity: null,
          price: null,
          total: 0,
        },
      ],
    },
    validationSchema: inputSchema,
  });

  const [unities, setUnities] = useState([]);
  const [supplies, setSupplies] = useState([]);

  const getValueTotal = totalValue(formik.values.items, 'total');

  useEffect(() => {
    async function load() {
      const unities_ = await api.get('/unities?showCustomUnities=true');
      setUnities(unities_.data);
      const supplies_ = await api.get('/supplies/');
      setSupplies(
        supplies_.data
          .filter((obj) => obj.isStocked === true)
          .sort((a, b) => a.name.localeCompare(b.name)),
      );
    }
    load();
  }, []);

  useEffect(() => {
    if (getValueTotal > 0) {
      updateTotalPrice(getValueTotal);
    }
  }, [getValueTotal, updateTotalPrice]);

  const hasInputs = formik.values.items && formik.values.items.length > 0;

  function setData(data) {
    if (!data) return;

    const { items } = data;

    formik.setValues({
      items,
    });
  }

  useLoadDataByLocation({ setData });

  const handleSubmit = async () => {
    try {
      await formik.submitForm();
    } catch (e) {}
  };

  useEffect(() => {
    callback({ isValid: formik.isValid, values: formik.values });
  }, [callback, formik.isValid, formik.values]);

  // Permite que o componente pai chame o método handleSubmit
  useImperativeHandle(ref, () => ({
    handleSubmit,
  }));

  return (
    <FormikProvider value={formik}>
      <CardWrapper
        title="Identificação"
      >
        <FieldArray name="items">
          {({ remove, push }) => (
            <Grid item container rowGap={2}>
              {hasInputs && (
                formik.values.items.map((_, index) => (
                  <InputGroup
                    key={index}
                    index={index}
                    unities={unities}
                    supplies={supplies}
                    setUnities={setUnities}
                    onRemove={() => remove(index)}
                    onAdd={() => push({
                      supply: null,
                      quantity: '',
                      unity: null,
                      price: null,
                      total: 0,
                    })}
                  />
                ))
              )}
            </Grid>
          )}
        </FieldArray>
      </CardWrapper>
    </FormikProvider>
  );
}

export default forwardRef(Input);
